import { render } from "./CardDetail.vue?vue&type=template&id=73d385f0&scoped=true"
import script from "./CardDetail.vue?vue&type=script&lang=js"
export * from "./CardDetail.vue?vue&type=script&lang=js"

import "../assets/css/cardDetail.css?vue&type=style&index=0&id=73d385f0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d385f0"]])

export default __exports__